import React from "react";
import ReactDOM from "react-dom/client";
import { ColorModeProvider } from "./theme/ColorModeContext.js";
import { App } from "./App.js";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ColorModeProvider>
      <App />
    </ColorModeProvider>
  </React.StrictMode>
);
